module.exports = __webpack_public_path__ + "img/testim2.027b68d7.png";